import * as $ from "jquery";

export interface StateCheckItem {
    tag: string;
    message: string;
    statecode: string;
}

export class StateCheck {
    statecheckitems: Array<StateCheckItem>;
    classtags: Array<string>;
    $warning: JQuery;
    $state: JQuery;

    constructor(
        statecheckitems: Array<StateCheckItem>,
        classtags: Array<string>,
    ) {
        this.statecheckitems = statecheckitems;
        this.classtags = classtags;
    }

    setup($warning: JQuery, $state: JQuery) {
        const self = this;
        this.$warning = $warning;
        this.$state = $state;

        this.$state.on("change", function () {
            self.doCheckControls();
        });

        this.doCheckControls();
    }

    doCheckControls() {
        const state = <string> this.$state.val();
        if (state) {
            this.doCheck(state);
        } else {
            this.$warning.hide();
        }
    }

    doCheck(statecode: string) {
        for (var item of this.statecheckitems) {
            if (item.statecode === statecode) {
                // see if ANY tag matches
                for (var classtag of this.classtags) {
                    if (classtag === item.tag) {
                        this.$warning.html(item.message).show();
                        return;
                    }
                }
            }
        }

        this.$warning.hide();
    }
}
